import Create from "./Create";

function CreateSection({ selectedRow }) {

    const NomeForm = "Nova Solicitação de Documentação para Fins de Serviço";

    return (
        <div className="row mt-4">
            <div className="col-12 col-md-12">
                <div className="block h-auto">
                    <div className="container-fluid">
                        <div className="row">

                            <div className="col-12 col-md-6 d-flex align-items-center">
                                <h2 className="mb-0">{NomeForm}</h2>
                            </div>

                            <Create
                                selectedRow={selectedRow}
                            />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateSection;